export const AGENT_NAME_CARD_TITLE = 'Licensed Brokerage';
export const AGENT_NAME_CARD_COMPANY = 'Hooli Home Boston Inc.';
export const AGENT_NAME_CARD_ADDRESS = '1619 Beacon St, Brookline, MA 02446';
export const AGENT_NAME_CARD_AVATAR = '/assets/hooli_agent_photo.png';
export const AGENT_NAME_CARD_PHONE = '4156130462';
export const AGENT_NAME_CARD_EMAIL = 'apply@hoolihomeboston.com';

export const parseAgentNameCardLanguages = (
  languages: string | null | undefined
): string[] =>
  String(languages ?? '')
    .split(',')
    .map(language => language.trim())
    .filter(Boolean);
